<template>
  <div class="box" :class="setClassModifiers('box--')" @click="$emit('click')">
    <div class="box__header mb-2" v-if="$slots.title || $slots.controls">
      <div class="box__title" v-if="$slots.title">
        <slot name="title"></slot>
      </div>
      <transition name="fade">
        <div class="box__controls" v-if="$slots.controls">
          <slot name="controls"></slot>
        </div>
      </transition>
    </div>
    <slot></slot>
  </div>
</template>

<script>
import setClassModifiers from '../../mixins/setClassModifiers'

export default {
  mixins: [setClassModifiers],
  props: {
    /**
     * @values white, green
     * */
    color: {
      type: String,
      default: 'white'
    },
    outline: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fullHeight: {
      type: Boolean,
      default: false
    },
    fullWidth: {
      type: Boolean,
      default: false
    },
    clickable: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
.box {
  background: $color-white;
  padding: $default-spacing-mobile;
  /*overflow: hidden;*/
  position: relative;

  &--clickable {
    @media (hover: hover) and (pointer: fine){
      &:hover {
        cursor: pointer;
      }
    }
  }

  @include respond(tab-port) {
    padding: $default-spacing;
  }

  border-radius: 1rem;
  border: 1px solid $color-space-lighten;
  box-shadow: 0 0 6px rgba(52, 48, 61, 0.08);

  &--green {
    background-color: $color-success;
  }

  &--info {
    background-color: $color-gold;
  }

  &--outline {
    box-sizing: initial;
  }

  &--outline {
    &.box--info {
      background-color: $color-white;
      border-color: $color-info;
    }

    &.box--green {
      background-color: $color-white;
      border-color: $color-success;
    }
  }

  &--small {
    padding: 10px;
  }

  &--x-small {
    padding: 3px 10px;
  }

  &--full-height {
    height: 100%;
  }

  &--full-width {
    width: 100%;
  }

  &__icon {
    font-size: 1.8rem;
  }

  &__header {
    display: flex;
  }

  &__controls {
    margin-left: auto;
    margin-right: -1rem;

    & > * {
      display: inline-block;
      font-size: 1.8rem!important;

      & > a {
        color: $color-black;
      }

      & > a:link {
        font-size: 1.8rem!important;
        color: $color-black;
      }
    }
  }

  &__title {
    width: 90%;
  }
}
</style>
